// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"578":"d6ce6297","692":"60e506f1"}[chunkId] + ".chunk.js";
};